// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

import { environment } from '@env/environment';

export const SERVER_API_URL = environment.serverUrl;
export const SERVER_FRONT_URL = environment.serverFrontUrl;
export const ASSETS_API_URL = environment.assetsUrl;
export const CDN_API_URL = environment.cdnUrl;
export const SIGNATURE_API_URL = environment.signatureUrl;
export const SIGNATURE_API_KEY = environment.SIGNATURE_API_KEY;
export const SERVICE_HUBSPOT_API_URL = environment.serviceHubspot;
